module.exports = __webpack_public_path__ + "img/fddx.eafb9e9c.jpg";